export default "__VITE_ASSET__BbWWor1b__"